export default __webpack_public_path__ + "static/media/taplinguabuy.f576bcf7.webp";